<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://play-gol.com" target="_blank"
        >PLAYGOL </b-link
      >
      <span class="d-none d-sm-inline-block"
        >, Todos los derechos reservados Versión {{VERSION}}</span
      >
    </span>

    <!-- <span class="float-md-right d-none d-md-block">
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span> -->
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { VERSION } from '@/utils/variables'

export default {
  components: {
    BLink,
  },
  data() {
    return {
      VERSION,
    }
  },
}
</script>
